import React from 'react';
import {
  BasicActionIcon,
  IBasicActionIconProps,
} from 'src/design/atoms/BasicActionIcon';

export type ITableToolbarActionIconProps = IBasicActionIconProps;

const DefaultProps: Partial<ITableToolbarActionIconProps> = {
  color: 'gray',
  variant: 'subtle',
};

/** @registry Subtle gray action icon sized for DataTable toolbars; use for generic table-level actions that aren't a dedicated icon variant. */
export const TableToolbarActionIcon = React.forwardRef<
  HTMLButtonElement,
  ITableToolbarActionIconProps
>(({ children, ...props }, ref) => {
  return (
    <BasicActionIcon {...DefaultProps} {...props} ref={ref}>
      {children}
    </BasicActionIcon>
  );
});
TableToolbarActionIcon.displayName = 'TableToolbarActionIcon';
